import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

import { ErrorFallback } from 'components/ErrorFallback';
import { Footer } from 'components/Footer';
import { LanguageSelector } from 'components/LanguageSelector';
import { useSciDomain } from 'components/SciDomainContext';
import { PageLayoutViewProps } from 'types';

export const DefaultPageLayoutView = ({ handleError }: PageLayoutViewProps) => {
  const { data: { logo, title } = {}, isLoading, isError } = useSciDomain();

  if (isLoading && !isError) {
    return null;
  }

  return (
    <div className="tw-flex tw-flex-col tw-w-screen tw-min-h-screen tw-p-5 tw-bg-layout md:tw-p-10">
      <title>{title}</title>
      <div className="tw-relative tw-flex tw-flex-col tw-items-center tw-w-full tw-max-w-sm tw-mx-auto md:tw-max-w-7xl">
        <div className="tw-absolute tw-top-3 tw-right-0 tw-h-10 md:tw-top-0 md:tw-h-15">
          <LanguageSelector />
        </div>
        {logo && (
          <img
            src={logo}
            alt={title || ''}
            className="tw-h-10 tw-mt-3 tw-mb-12 tw-mx-auto md:tw-mt-0 md:tw-h-15 md:tw-mb-12"
          />
        )}
      </div>

      <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleError}>
        <Outlet />
      </ErrorBoundary>

      <div className="tw-mt-10 md:tw-mt-20" />
      <Footer />
    </div>
  );
};
